import { render, staticRenderFns } from "./MoondayDownload.vue?vue&type=template&id=4710b1fd&scoped=true&"
import script from "./MoondayDownload.vue?vue&type=script&lang=js&"
export * from "./MoondayDownload.vue?vue&type=script&lang=js&"
import style0 from "./MoondayDownload.vue?vue&type=style&index=0&id=4710b1fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4710b1fd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\other\\DaMou-Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4710b1fd')) {
      api.createRecord('4710b1fd', component.options)
    } else {
      api.reload('4710b1fd', component.options)
    }
    module.hot.accept("./MoondayDownload.vue?vue&type=template&id=4710b1fd&scoped=true&", function () {
      api.rerender('4710b1fd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/月亮日記/MoondayDownload.vue"
export default component.exports